import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import './simpleslider.css';
// import eventsArray from '../events.json'
import events from '../events.json'

export default function SimpleSlider() {


  var settings1 = {
    arrows: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    // centerMode: true,
    // adaptiveHeight: true,
    
    responsive: [
      {
        breakpoint: 1273,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2,
          // centerMode:true
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          // centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          // centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]

  };

  // const [lastEvent, setLastEvent] = useState({});
  // const [events, setEvents] = useState([]);

  // useEffect(() => {
  //   console.log("events", eventsArray);
  //   console.log("from did");
  //   let sortedArray = eventsArray.sort(function (a, b) {
  //     return new Date(b.date) - new Date(a.date);
  //   });

  //   console.log("a", sortedArray);

  //   let latestEvent = sortedArray.shift();
  //   console.log("d", latestEvent);
  //   // this.setState({ latestEvent: latestEvent, events: sortedArray })
  //   setEvents(sortedArray);
  //   setLastEvent(latestEvent)
  // }, []);




  return (
    
    <div className="events-div">
      {events.map(event => {
        return (
          <div className="each-slider">
            
            <div className="event-info">
               <h4 style={{ fontWeight: 800, fontSize: 'large' }}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-geo-alt" viewBox="0 0 16 16" style={{ color: '#ffc200', marginBottom: '3px' }} >
                <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z" />
                <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
              </svg>       {event.location}</h4>
              <h5 >{event.date}</h5>
            </div>
            <Slider {...settings1} className="slider-comp">
              {
                event.other.map(img => {
                  return <img className='slider-img' src={img} alt='' />
                })
              }


            </Slider>
          </div>)
      })}

    </div>
  );
}